<template>
Condition
</template>

<script>
export default {
  name: 'ConditionSettings',
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
